import { Injectable } from '@angular/core';

export interface ExternalMapProvider {
  label: string;
  url: string;
}

export const EXTERNAL_MAP_PROVIDERS: { [key: string]: ExternalMapProvider } = {
  google: {
    label: "maps.google.com",
    url: "https://maps.google.com/?q=[LATITUDE],[LONGITUDE]"
  },
  geoportail: {
    label: "cartes.gouv.fr",
    url: "https://cartes.gouv.fr/explorer-les-cartes?c=[LONGITUDE],[LATITUDE]&z=19&l=PLAN.IGN$GEOPORTAIL:GPP:TMS(1;1;1;0;standard)&permalink=yes"
  },
  arcep: {
    label: "cartefibre.arcep.fr",
    url: "https://cartefibre.arcep.fr/index.html?lng=[LONGITUDE]&lat=[LATITUDE]&zoom=18&mode=normal&legende=true&filter=true&trimestre=2025T3"
  },
  bing: {
    label: "maps.bing.com",
    url: "https://www.bing.com/maps?cp=[LATITUDE]~[LONGITUDE]&lvl=19.7&style=r"
  }
};

@Injectable({
  providedIn: 'root',
})
export class ExternalMapProvidersService {
  public static getExternalMapProviderUrl(provider: string, latitude: number, longitude: number) {
    const externalMapProvider = EXTERNAL_MAP_PROVIDERS[provider];

    if (!externalMapProvider) {
      return undefined;
    }

    return externalMapProvider.url.replace('[LATITUDE]', latitude.toString()).replace('[LONGITUDE]', longitude.toString());
  }
}
